import React from "react";
import { FormField } from "./FormField";
import FileUpload from "../../../../shared/ui/file-uploader/FileUpload";
import { ArticleImage } from "../../../../entities/article";

interface ImageFieldProps {
  images: ArticleImage[];
  onAdd: () => void;
  onRemove: (index: number) => void;
  onChange: (index: number, field: keyof ArticleImage, value: string) => void;
  onFileUpload: (index: number, file: File) => void;
  onMoveUp: (index: number) => void;
  onMoveDown: (index: number) => void;
  uploadingImages: Set<number>;
}

export const ImageField: React.FC<ImageFieldProps> = ({
  images,
  onAdd,
  onRemove,
  onChange,
  onFileUpload,
  onMoveUp,
  onMoveDown,
  uploadingImages,
}) => {
  return (
    <FormField label="이미지" className="image-field">
      <div className="images-container">
        {images.map((image, index) => (
          <div
            key={`image-${image.order}-${image.imageUrl || index}`}
            className="image-item"
          >
            <div className="image-header">
              <div className="image-title-section">
                <h4>이미지 {index + 1}</h4>
                <span className="order-badge">순서: {image.order + 1}</span>
              </div>
              <div className="image-controls">
                <div className="order-controls">
                  <button
                    type="button"
                    onClick={() => onMoveUp(index)}
                    disabled={index === 0}
                    className="move-btn move-up"
                    title="위로 이동"
                  >
                    ↑
                  </button>
                  <button
                    type="button"
                    onClick={() => onMoveDown(index)}
                    disabled={index === images.length - 1}
                    className="move-btn move-down"
                    title="아래로 이동"
                  >
                    ↓
                  </button>
                </div>
                {images.length > 1 && (
                  <button
                    type="button"
                    onClick={() => onRemove(index)}
                    className="remove-image-btn"
                    title="이미지 삭제"
                  >
                    ×
                  </button>
                )}
              </div>
            </div>

            <div className="image-inputs">
              <div className="image-url-section">
                <label id={image.id}>이미지 URL</label>
                <div className="image-input-container">
                  <input
                    id={image.id}
                    type="url"
                    value={image.imageUrl}
                    onChange={(e) =>
                      onChange(index, "imageUrl", e.target.value)
                    }
                    placeholder="이미지 URL을 입력하세요"
                    className="image-url-input"
                  />
                  <FileUpload
                    onFileSelect={(file) => {
                      if (file) {
                        onFileUpload(index, file);
                      }
                    }}
                    className="image-upload-btn"
                    disabled={uploadingImages.has(index)}
                    currentImageUrl={image.imageUrl}
                  />
                  {uploadingImages.has(index) && (
                    <div className="uploading-indicator">업로드 중...</div>
                  )}
                </div>
              </div>

              <div className="image-descriptions">
                <div className="description-input">
                  <label>한국어 설명</label>
                  <input
                    type="text"
                    value={image.descKo || ""}
                    onChange={(e) => onChange(index, "descKo", e.target.value)}
                    placeholder="한국어 설명을 입력하세요"
                  />
                </div>
                <div className="description-input">
                  <label>영어 설명</label>
                  <input
                    type="text"
                    value={image.descEn || ""}
                    onChange={(e) => onChange(index, "descEn", e.target.value)}
                    placeholder="영어 설명을 입력하세요"
                  />
                </div>
              </div>
            </div>
          </div>
        ))}

        <button type="button" onClick={onAdd} className="add-image-btn">
          + 이미지 추가
        </button>
      </div>
    </FormField>
  );
};
